import React, { useEffect, useState } from "react";
import styled from 'styled-components';

const Wrapper = styled.div`
  position:-webkit-sticky; 
  position:sticky;
  top:20px;
  dl, ol, ul { margin-top: 0; margin-bottom: 0; }
  h4{
    padding: 10px;
    background-color: #333;
    color: white;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
  }
  ul.toc-list { padding-left: 0; }
  #side-toc > ul.toc-list > li {
      list-style-type: none;
      margin: 0 5px;
      font-size: 13px;
      counter-increment: h2;
      padding: 0 6px;
  }
  #side-toc > ul.toc-list > li:before { content: counter(h2) ". "; }
  ul.toc-list > li.is-current { background-color: #eee; }
  ul.toc-list > li > a { color: black; text-decoration: none; border-bottom: 0;}
  ul.toc-list > li.is-current > a { color: black; font-weight:bold;}
  ul.toc-list > li.is-current > ul.toc-list { display: block; }
  ul.toc-list > li > ul.toc-list { display: none; margin: 0; }
  #side-toc > ul.toc-list > li > ul.toc-list > li {
      font-size: 11px;
      counter-increment: h3;
      list-style-type: none;
      padding: 0 10px;
  }
  #side-toc > ul.toc-list > li > ul.toc-list > li:before { 
    content: counter(h2) "." counter(h3) " ";
  }
  @media only screen and (max-width: 1000px) {
      #side-toc{
          display: none;
      }
  }
`;

const Headings = ({ headings, activeId }:{headings: any, activeId: any}) => (
  <ul className="toc-list">
    {headings.items.map((heading: any) => (
      <li key={heading.url} className={heading.url.slice(1) === activeId.h2 ? "is-current" : ""}>
        <a
          href={`${heading.url}`}
          onClick={(e) => {
            e.preventDefault();
            document.querySelector(`${heading.url}`)?.scrollIntoView({
              behavior: "smooth"
            });
          }}
        >
          {heading.title}
        </a>
        {heading.items && (
          <ul className="toc-list">
            {heading.items.map((child: any) => (
              <li
                key={child.url}
                className={child.url.slice(1) === activeId.h3 ? "is-current" : ""}
              >
                <a
                  href={`${child.url}`}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(`${child.url}`)?.scrollIntoView({
                      behavior: "smooth"
                    });
                  }}
                >
                  {child.title}
                </a>
              </li>
            ))}
          </ul>
        )}
      </li>
    ))}
  </ul>
);

function getIds(items: any) {
  if(items === undefined) return;
  return items.reduce((acc: any, item: any) => {
    if (item.url) {
      // url has a # as first character, remove it to get the raw CSS-id
      acc.push(item.url.slice(1));
    }
    if (item.items) {
      acc.push(...getIds(item.items));
    }
    return acc;
  }, []);
}

/**
 * Renders the table of contents.
 */
const TableOfContents2 = (props: any) => {
  const { toc } = props;
  //console.log(toc);
  const idList = getIds(toc.items);
  if(idList === undefined){
    return (<div></div>);
  }
  // console.log(idList);
  const [activeId, setActiveId] = React.useState({
    h2: idList[0],
    h3: 'h3'
  });
  useEffect(() => {
    //console.log(activeId);
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry,index) => {
        if (entry.isIntersecting) {
          switch (entry.target.tagName) {
            case "H2":
              setActiveId({ ...activeId, h2: entry.target.id });
              break;
            case "H3":
              setActiveId({ ...activeId, h3: entry.target.id });
              break;
            default:
              break;
          }
          // setActiveId(entry.target.id);
          // entry.target.classList.add('is-current');
        }
      });
    },
    { rootMargin: `0px 0px -300px 0px` }
    );
    idList.forEach((id: any) => {
      const elm = document.getElementById(id);
      if(elm != null){ observer.observe(elm); }
    });
    return () => {
      idList.forEach((id: any) => {
        const elm = document.getElementById(id);
        if(elm != null){ observer.unobserve(elm); }
      });
    };
  }, [idList]);
  return (
    <Wrapper>
      <nav id="side-toc" className="mt-4">
        <h4>ページ目次</h4>
        <Headings headings={toc} activeId={activeId} />
      </nav>
    </Wrapper>
  );
};

 export default TableOfContents2;